import { FormControl, Grid, TextField, Typography } from "@material-ui/core";
import CardTable from "components/CardTable/CardTable";
import RegularButton from "components/CustomButtons/Button";
import React, { useEffect, useState } from "react";
import { columnsCondition } from "./columnsConditions";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import AddIcon from "@material-ui/icons/Add";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "hooks/useForm";
import { animations } from "helpers/animations";
import { addCustomerCondition } from "redux/actions/customers/customersAction";
import { Autocomplete } from "@material-ui/lab";
import { cleanNumber } from "helpers/cleanNumbers";
import { useSearch } from "hooks/useSearch";
import { initialValues, valuesRequired } from "./inputValues";

export const CustomerConditionsForm = () => {
  const tableKey = "customersConditions";
  const dispatch = useDispatch();
  const { customerConditions, customer } = useSelector(
    ({ customersReducer }) => customersReducer
  );
  const { conditions } = useSelector(
    ({ conditionsReducer }) => conditionsReducer
  );
  const { setSnackbar } = useSearch({
    tableKey,
  });
  const {
    inputValues,
    handleInputOnChange,
    onChangeNumber,
    handleNewValues,
    cleanForm,
    errors,
    runValidatesExe,
  } = useForm(initialValues, valuesRequired);
  const {
    origin,
    agreedVolume,
    idCondition,
    quantity,
    description,
    isLimited,
    condition,
    showQuantityInput,
  } = inputValues;

  const addInfo = () => {
    const exist = customerConditions.conditions.some(
      (cond) => cond.idComercialCondition === condition.value
    );
    if (exist && isLimited)
      return setSnackbar("Esta condición ya fue agregada", "warning");
    const { metricUnit } = condition;
    const cQuantity = cleanNumber(quantity) || quantity;
    const newQuantity = cQuantity > 0 ? cQuantity : metricUnit;
    let newLabel;
    if (metricUnit === "$") {
      newLabel = `${metricUnit} ${newQuantity}`;
    } else if (
      metricUnit === "N/A" ||
      metricUnit === "SI" ||
      metricUnit === "NO"
    ) {
      newLabel = metricUnit;
    } else {
      newLabel = `${newQuantity} ${condition.metricUnit} `;
    }

    const newCondition = {
      idComercialCondition: condition.value,
      name: condition.label,
      quantity: newLabel,
      description,
    };
    const form = {
      origin,
      agreedVolume: cleanNumber(agreedVolume),
      comercialConditions: [{ ...newCondition }],
    };
    dispatch(addCustomerCondition(customer.id, form, cleanForm));
  };

  const handleAdd = () => runValidatesExe([], addInfo);

  useEffect(() => {
    Object.keys(customerConditions).length > 0 && handleNewValues(inputValues);
    //eslint-disable-next-line
  }, [customerConditions]);

  useEffect(() => {
    const findCondition = conditions.find(
      (cond) => cond.id === idCondition?.id
    );
    // debugger
    handleNewValues({
      isLimited: findCondition?.limited,
      condition: findCondition,
    });
    //eslint-disable-next-line
  }, [idCondition]);

  useEffect(() => {
    condition?.metricUnit !== "N/A" &&
    condition?.metricUnit !== "SI" &&
    condition?.metricUnit !== "NO"
      ? handleNewValues({ showQuantityInput: true, quantity: "" })
      : handleNewValues({ showQuantityInput: false });
    condition?.metricUnit === "N/A" && handleNewValues({ quantity: "N/A" });
    condition?.metricUnit === "SI" && handleNewValues({ quantity: "SI" });
    condition?.metricUnit === "NO" && handleNewValues({ quantity: "NO" });

    //eslint-disable-next-line
  }, [condition]);

  return (
    <FormControl fullWidth>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Procedencia *"
            name="origin"
            value={origin}
            onChange={handleInputOnChange}
            variant="outlined"
            error={errors.origin || ""}
            helperText={errors.origin || ""}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Volumen pactado *"
            name="agreedVolume"
            InputProps={{
              endAdornment: <p style={{ margin: 0 }}>Kg</p>,
            }}
            value={agreedVolume}
            onChange={onChangeNumber}
            variant="outlined"
            inputProps={{
              right: "1",
            }}
            error={errors.agreedVolume || ""}
            helperText={errors.agreedVolume || ""}
          />
        </Grid>
        <Grid item xs={12} sm={8}>
          <Autocomplete
            id="conditions-autocomplete"
            options={conditions}
            value={idCondition}
            getOptionLabel={(condition) => condition.label}
            renderInput={(params) => (
              <TextField
                {...params}
                name="idCondition"
                label="Condiciones"
                variant="outlined"
                error={errors.idCondition || ""}
                helperText={errors.idCondition || ""}
              />
            )}
            fullWidth
            onChange={(_, v) => handleNewValues({ idCondition: v })}
          />
          {isLimited && (
            <Typography
              className={animations.fadeIn}
              variant="caption"
              color="secondary"
              style={{ paddingTop: 12 }}
            >
              Esta condición solo puede ser aplicada una vez
            </Typography>
          )}
        </Grid>

        <Grid item xs={12} sm={2}>
          <TextField
            fullWidth
            label={showQuantityInput ? "Cantidad" : "Cantidad N/A"}
            name="quantity"
            value={quantity}
            onChange={onChangeNumber}
            variant="outlined"
            disabled={!showQuantityInput}
            inputProps={{
              right: "1",
            }}
            error={errors.quantity || ""}
            helperText={errors.quantity || ""}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            fullWidth
            label="U. metrica"
            name="metricUnit"
            value={condition?.metricUnit || ""}
            variant="outlined"
            disabled
            inputProps={{
              style: {textAlign: 'center'}
            }}
          />
        </Grid>
        <Grid item xs={10} sm={11}>
          <TextField
            fullWidth
            label="Detalles"
            name="description"
            value={description}
            onChange={handleInputOnChange}
            variant="outlined"
            multiline
          />
        </Grid>
        <Grid
          item
          xs={2}
          sm={1}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <RegularButton
            justIcon
            round
            color="info"
            tooltip="Agregar Condición"
            onClick={handleAdd}
          >
            <AddIcon style={{ margin: 0 }} />
          </RegularButton>
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}
        >
          <CardTable
            hasHeader
            title="Agregar/Remover"
            icon={<ImportContactsIcon />}
            columns={columnsCondition}
            data={customerConditions.conditions}
            blockBtn
            showPageSize={false}
            hasControl
            pageSize={5}
            tableKey={tableKey}
          />
        </Grid>
      </Grid>
    </FormControl>
  );
};
